import Preloader from '../../../ui/svg/common/preloader';
import React, { ChangeEvent, useEffect, useState } from 'react';
import {
    getGdprCookie,
    getGdprCountry,
    IGdpr,
    isGpcEnabled,
    setGDPRCookie,
    setGpcSessionCookie
} from '../domain/gdpr-provider';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import { COOKIE_POLICY_GA_EVENT_TITLE } from './cookie-policy';
import { format } from 'date-fns';
import { updateGDPR } from '../data/data-service';
import { getHiddenDataString, getIsAuthenticated } from '../../../domain/hidden-data-provider';

const CookiePolicyButtonForm = () => {

    const [isMarketing, setIsMarketing] = useState(true);
    const [isPerformance, setIsPerformance] = useState(true);
    const [isFunctional, setIsFunctional] = useState(true);

    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState('');

    useEffect(() => {
        const cookie = getGdprCookie();
        setIsMarketing(cookie.IsMarketing);
        setIsPerformance(cookie.IsPerformance);
        setIsFunctional(cookie.IsFunctional);
    }, []);

    const onMarketingChange = (evt: ChangeEvent<HTMLInputElement>) => {
        setIsMarketing(evt.currentTarget.checked);
    };

    const onPerformanceChange = (evt: ChangeEvent<HTMLInputElement>) => {
        setIsPerformance(evt.currentTarget.checked);
    };

    const onFunctionalChange = (evt: ChangeEvent<HTMLInputElement>) => {
        setIsFunctional(evt.currentTarget.checked);
    };

    const save = async () => {

        setMsg('');
        setLoading(true);

        const data: IGdpr = {
            IsMarketing: isMarketing,
            IsPerformance: isPerformance,
            IsFunctional: isFunctional,
            ItemModifiedWhen: format(new Date(),'MM/dd/yyyy HH:mm:ss'),
            IsCountryGDPR: getHiddenDataString('gdpr-country') || 'u'
            //ItemModifiedWhen: this.state.gdprMacro ? this.state.gdprMacro.ItemModifiedWhen : Date.now().toString('MM/dd/yyyy HH:mm:ss')
        };

        setGDPRCookie(data);

        const isUserLoggedIn = getIsAuthenticated();
        if(isUserLoggedIn) {
            await updateGDPR(true);
        }

        setLoading(false);
        setMsg('Thank you. Your preferences were saved.');

        sendGAEvent(COOKIE_POLICY_GA_EVENT_TITLE, 'Save Settings');

        const country = getGdprCountry();
        if(country === 'y' && isGpcEnabled()) {
            setGpcSessionCookie();
        }

        window.setTimeout(() => {
            setMsg('');
        }, 3000);
    };

    return (
       <>
          {/* <p id="customize" style={ {
               scrollMarginTop: '100px'
           } }>&nbsp;</p>*/}

           <div>
               <div className="mb-8">
                   <label>
                       <input
                           className="mr-2 font-bold"
                           type="checkbox"
                           checked={ true }
                           disabled={ true }
                           aria-disabled="true"
                           aria-describedby="required-cookies-desc"
                       />
                       <span className="font-bold">Essential Technologies (Strictly Necessary)</span>
                   </label>

                   <div id="required-cookies-desc">These technologies are required for the Services to function properly and are always active. They cannot be turned off using these controls.
                   </div>
               </div>

               <div className="mb-8">
                   <label>
                       <input
                           className="mr-2 pointer-cursor font-bold"
                           type="checkbox"
                           checked={ isFunctional }
                           onChange={ onFunctionalChange }
                       />
                       <span className="cursor-pointer font-bold">Enable Functional Technologies</span>
                   </label>

                   <div>These technologies enable enhanced functionality and personalization (for example, video playback, user-generated content, and site preferences). When disabled, certain features may not function properly or may be unavailable.</div>
               </div>

               <div className="mb-8">
                   <label>
                       <input
                           className="mr-2 pointer-cursor font-bold"
                           type="checkbox"
                           checked={ isPerformance }
                           onChange={ onPerformanceChange }
                       />
                       <span className="cursor-pointer font-bold">Enable Performance Technologies</span>
                   </label>

                   <div>These technologies help us understand how users interact with the Services, such as page visits, clicks, navigation patterns, device and browser information. We use this data to identify areas to improve our products and services.</div>
               </div>

               <div>
                   <label>
                       <input
                           className="mr-2"
                           type="checkbox"
                           checked={ isMarketing }
                           onChange={ onMarketingChange }
                       />
                       <span className={ 'cursor-pointer font-bold' }>Enable Advertising Technologies</span>
                   </label>

                   <div>When enabled, these technologies allow us and our partners to deliver and measure advertising, including providing more relevant ads and offers. When disabled, you may still see ads, but they may be less relevant.</div>
               </div>

               <div className="mt-6">
                   {
                       !loading &&
                       <button
                           type="button"
                           className="w-btn w-fit"
                           onClick={ save }>
                           Save Preferences
                       </button>
                   }

                   {
                       loading &&
                       <Preloader
                           width="24px"
                           height="24px"
                           color="#4f4f4f"
                       />
                   }
               </div>

               {
                   msg &&
                   <div className="ok-box mt-10 xl:w-5/12">{ msg }</div>
               }
           </div>
       </>
    )
};

export default CookiePolicyButtonForm;